import { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
// import { IoClose, IoMenu } from 'react-icons/io5';
import './Navbar.css';
import companyLogo from '../assets/company-logo.png';

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  return (
    <header>
      <nav className={`topnav ${showMenu ? 'responsive' : ''}`} id="myTopnav">
        <Link to="/">
          <img id="icon-logo" src={companyLogo} height="19" />
          <span className="companyName">bluEggDev</span>
        </Link>
        {/* <ul> */}
        {/* <li> */}
        <NavLink to="/">Home</NavLink>
        {/* </li> */}
        {/* <li> */}
        {/* <NavLink to="/about">About</NavLink> */}
        {/* </li> */}
        {/* <li> */}
        <NavLink to="/projects">Projects</NavLink>
        <NavLink to="/drills">Drills</NavLink>
        <NavLink to="/screws">Screws</NavLink>

        {/* <NavLink to="/feeds">Feeds</NavLink> */}
        {/* <NavLink to="/cylfits">Fits</NavLink> */}
        {/* </li> */}
        {/* <li> */}
        <NavLink className="split" to="/contact">
          Contact Us
        </NavLink>
        {/* </li> */}
        <Link to="#" className="icon" onClick={toggleMenu}>
          <i className="fa fa-bars"></i>
        </Link>
        {/* </ul> */}
      </nav>
    </header>
  );
};

export default Navbar;

/*
<nav>
      <div class="topnav" id="myTopnav">
        <a href="home">
          <img id="icon-logo" src="./images/company-logo.png" height="19" />
          <span class="companyName">bluEggDev</span>
        </a>

        <a href="home">Home</a>
        <a href="about">About</a>
        <a href="projects">Projects</a>
        <a href="contact" class="split">Free Consult</a>
        <a href="javascript:void(0);" class="icon" onclick="myFunction()">
          <i class="fa fa-bars"></i>
        </a>
      </div>
    </nav>
*/
